var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H31C31.5523 0 32 0.447715 32 1C32 1.55228 31.5523 2 31 2H1C0.447715 2 0 1.55228 0 1ZM16 7C16 6.44772 16.4477 6 17 6H31C31.5523 6 32 6.44772 32 7C32 7.55228 31.5523 8 31 8H17C16.4477 8 16 7.55228 16 7ZM1 12C0.447715 12 0 12.4477 0 13C0 13.5523 0.447715 14 1 14H31C31.5523 14 32 13.5523 32 13C32 12.4477 31.5523 12 31 12H1Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMenu);
export default __webpack_public_path__ + "static/media/buttonMenu.ae6e88872a0425a73a55eb9a9462b76c.svg";
export { ForwardRef as ReactComponent };